type BrowserNotificationPayload = {
  title: string;
  body?: string;
  tag?: string;
  url?: string;
};

export function canShowBrowserNotification(): boolean {
  return typeof window !== "undefined" && "Notification" in window && Notification.permission === "granted";
}

export function showBrowserNotification({
  title,
  body,
  tag,
  url = "/conversations",
}: BrowserNotificationPayload) {
  if (!canShowBrowserNotification()) return;

  try {
    // `renotify` is supported by browsers but not declared in the lib DOM type used here.
    const options = {
      body,
      tag,
      icon: "/icons/app-icon-512.png?v=8",
      badge: "/icons/app-icon-192.png?v=8",
      renotify: true,
    } as NotificationOptions;

    const notification = new Notification(title, options);

    notification.onclick = () => {
      window.focus();
      window.location.assign(url);
      notification.close();
    };
  } catch (error) {
    console.warn("[notifications] failed to show browser notification:", error);
  }
}
